import { useState } from 'react';

export const useMirrorPermissions = (onApplyPermissions) => {
  const [mirrorDialogOpen, setMirrorDialogOpen] = useState(false);
  const [mirrorPermissionType, setMirrorPermissionType] = useState(null);

  const handleOpenMirrorDialog = (permissionType) => {
    setMirrorPermissionType(permissionType);
    setMirrorDialogOpen(true);
  };

  const handleCloseMirrorDialog = () => {
    setMirrorDialogOpen(false);
    setMirrorPermissionType(null);
  };

  const handleApplyMirroredPermissions = (mirroredPermissions, sourceUser) => {
    if (onApplyPermissions) {
      onApplyPermissions(mirroredPermissions, sourceUser, mirrorPermissionType);
    }
    handleCloseMirrorDialog();
  };

  return {
    mirrorDialogOpen,
    mirrorPermissionType,
    openMirrorDialog: handleOpenMirrorDialog,
    closeMirrorDialog: handleCloseMirrorDialog,
    applyMirroredPermissions: handleApplyMirroredPermissions,
  };
};
